export const INFO_PAGE_QUERY_PARAM = "page";

/**
 * @param {string} [search]
 * @returns {string | null}
 */
export function parseInfoPageIdFromSearch(search = "") {
  const params = new URLSearchParams(search.startsWith("?") ? search : `?${search}`);
  const pageId = params.get(INFO_PAGE_QUERY_PARAM);
  return pageId?.trim() || null;
}

/**
 * @param {string} baseUrl
 * @param {string} pageId
 */
export function buildInfoPageUrl(baseUrl, pageId) {
  const url = new URL(baseUrl);
  url.searchParams.set(INFO_PAGE_QUERY_PARAM, pageId);
  return url.toString();
}
